<div class="profile-container">
  <div class="profile">
    <div class="profile__user">
      <div class="profile__avatar">
        <messaging-avatar
          (click)="openProfile()"
          [name]="$safeNavigationMigration(currentUserSesion()?.subjectMessageableEntity?.displayName)"
          [src]="$safeNavigationMigration(currentUserSesion()?.subjectMessageableEntity?.profileImageURL)"
          [initialsSize]="2"
          size="45">
        </messaging-avatar>
      </div>
      <div class="profile__user-info">
        <p class="profile__user-info-title">
          {{ currentUserSesion()?.subjectMessageableEntity?.displayName }}
        </p>
        <p class="profile__user-info-subtitle">{{ currentUserSesion()?.provider }}</p>
      </div>
    </div>
    <div>
      <ng-content select="[actions]"> </ng-content>
    </div>
  </div>
  @if(currentUserSesion()?.away){
  <div class="away-container" (click)="cancelAway()">
    Away until {{ currentUserSesion()?.away?.to | date : 'MMMM dd hh:mm aa' }}
  </div>
  }
</div>
